import { _GLOBALS } from '../globals.js';
import { logit } from "./simpleLog.js";
import { detectPlatform } from "./detectPlatform.js";

/* Detect if we are inside the wallet browser; if so, return only this wallet. */
export function detectWallets() {
  const wallets = [
    {
      name: "Coinbase",
      icon: "/coinbase_wallet.svg",
      detected: window?.coinbaseSolana ? true : false,
      inAppBrowser: false,
    },
    {
      name: "Solflare",
      icon: "/solflare.jpg",
//      detected: window.solflare?.isSolflare ? true : false,
//      inAppBrowser: false,
        detected: window.solflare?.isSolflare || /Solflare/i.test(navigator.userAgent),
        inAppBrowser: /Solflare/i.test(navigator.userAgent),
    },
    
    /*
    {
      name: "Phantom",
      icon: "/phantom_wallet.svg",
      detected: window.phantom?.solana?.isPhantom ? true : false,
      inAppBrowser: false,
    },
    */
  ];

  // Check the platform
  if (detectPlatform() !== "Other") {
    if(_GLOBALS.DebugMode) logit("Check if in app browser");
    // Find the first wallet with detected === true
    const inAppBrowser = wallets.find((wallet) => wallet.detected);
    // Return the detected wallet or null if none found
    if (inAppBrowser) return [{ ...inAppBrowser, inAppBrowser: true }];
  }

  return wallets;
}
